import React from 'react';
import { Divider } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

export interface ButtonDividerProps {
  /** Additional sx styles to apply */
  sx?: SxProps<Theme>;
}

/**
 * A vertical divider component used to separate toolbar buttons
 * Used in list pages like ProjectsList, LineItemsList, etc.
 */
export const ButtonDivider: React.FC<ButtonDividerProps> = ({ sx }) => {
  return (
    <Divider
      orientation='vertical'
      flexItem
      sx={{
        mx: 1,
        height: '32px',
        alignSelf: 'center',
        borderRightWidth: 1,
        borderColor: 'rgba(0,0,0,0.15)',
        ...sx,
      }}
    />
  );
};

export default ButtonDivider;
